import { render } from "./daytwo.vue?vue&type=template&id=c2c9f4e6"
import script from "./daytwo.vue?vue&type=script&lang=js"
export * from "./daytwo.vue?vue&type=script&lang=js"

import "./daytwo.vue?vue&type=style&index=0&id=c2c9f4e6&lang=scss"
script.render = render

export default script